import type * as React from 'react';

import { PageWallpaper } from '@gitbook/spine-react';

import { glassGradient } from '../../assets';

export function AccessWall({ children }: { children: React.ReactNode }): React.ReactElement {
    return (
        <PageWallpaper
            imageLight={glassGradient.light}
            imageDark={glassGradient.dark}
            className="flex-1 bg-top"
        >
            <div className="flex h-full w-full flex-col items-center justify-center p-4 pt-16 md:p-12 md:pt-24 xl:p-20 xl:pt-36">
                {children}
            </div>
        </PageWallpaper>
    );
}
